/**
 * Módulo F-22 AT 2026 - Régimen 14D8
 * Estructura preparada - pendiente de implementar con plantilla 14D8.
 */

export const createInitialState = () => ({
  anioTributario: 2026,
  anioComercial: 2025,
  regimen: '14d8',
  antecedentes: {},
  // TODO: Agregar secciones específicas del régimen 14D8 cuando se tenga la plantilla
});

export const recalculate = (data) => ({});

export const SECTIONS = [
  // TODO: Definir secciones del 14D8 cuando se tenga la plantilla
];
